/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * HRHomeIcon - Auto-generated from icon.js
 */
export const HRHomeIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M7.33333 18V11.9136C7.33333 11.3534 7.8109 10.8992 8.4 10.8992H11.6C12.1891 10.8992 12.6667 11.3534 12.6667 11.9136V18M9.38184 2.18771L2.44851 6.87647C2.16713 7.06676 2 7.3748 2 7.70316V16.4784C2 17.3188 2.71634 18 3.6 18H16.4C17.2837 18 18 17.3188 18 16.4784V7.70316C18 7.3748 17.8329 7.06676 17.5515 6.87647L10.6182 2.18771C10.2481 1.93743 9.75193 1.93743 9.38184 2.18771Z" stroke="#333333" stroke-linecap="round" />
	</svg>
);

export default HRHomeIcon;
